<template>
  <SingleNews />
</template>

<script>
import SingleNews from '@/components/content/news/EditSelectedNews.vue'

export default {
  name: 'ContentSingleNews',
  components: { SingleNews }
}
</script>

<style scoped>

</style>
